var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "messages-desc" }, [
      _c("span", {
        domProps: { innerHTML: _vm._s(_vm.$t("campaigns.sampleMessageDesc1")) },
      }),
      _c("span", {
        domProps: { innerHTML: _vm._s(_vm.$t("campaigns.sampleMessageDesc2")) },
      }),
      _c("span", {
        domProps: { innerHTML: _vm._s(_vm.$t("campaigns.sampleMessageDesc3")) },
      }),
    ]),
    !!_vm.errors.sample1 && _vm.messages.length === 0
      ? _c("div", { staticClass: "Vlt-red-dark Vlt-margin--A-bottom2" }, [
          _vm._v(" " + _vm._s(_vm.errors.sample1) + " "),
        ])
      : _vm._e(),
    _c(
      "div",
      [
        _vm._l(_vm.messages, function (message, index) {
          return _c(
            "div",
            { key: index, staticClass: "input-and-button" },
            [
              _c("text-field", {
                staticClass: "sample-message-input",
                attrs: {
                  "data-cy": "sms-registration-sample-message-input",
                  id: `sample${index}`,
                  label: _vm.$t(`campaigns.sample${index + 1}`),
                  "validation-message": _vm.sampleMessagesErrorMessage,
                  value: message,
                  pattern: _vm.sampleMessageLengthRegex,
                  readOnly: _vm.readOnly,
                },
                on: { textChanged: (val) => _vm.handleTextChange(val, index) },
              }),
              _c(
                "div",
                { staticClass: "input-and-button__button" },
                [
                  index + 1 > _vm.unremovable
                    ? _c("cd-button", {
                        staticClass: "tendlc-icon-only",
                        attrs: {
                          id: `sample${index}_deleteBtn`,
                          icon: "delete-line",
                          disabled:
                            _vm.readOnly ||
                            (_vm.messages.length <= _vm.sampleMessagesMin &&
                              index < _vm.sampleMessagesMin) ||
                            index + 1 <= _vm.unremovable,
                          layout: "text",
                          connotation: "alert",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        _c(
          "div",
          { staticClass: "add-button" },
          [
            _c("cd-button", {
              attrs: {
                icon: "add-line",
                label: _vm.$t("campaigns.addSampleMessage"),
                disabled: _vm.readOnly || _vm.maxed,
                layout: "text",
                connotation: "cta",
              },
              on: { click: _vm.next },
            }),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }